import { TitleFetchCondition, TitleModel } from "./title.state";

export class FetchTitle {
    static readonly type = '[Title] Fetch Title';
    constructor(public condition?: TitleFetchCondition, public checkExist: boolean = true) { }
}

export class AddTitle {
    static readonly type = '[Title] Add Title';
    constructor(public title: TitleModel) { }
}

export class GetTitleList {
    static readonly type = '[Title] Get list Title';
    constructor() { }
}

export class GetSelectTitle {
    static readonly type = '[Title] Get Title';
    constructor(public ttlkbn: string, public ttlcd: string) { }
}